// extracted by mini-css-extract-plugin
module.exports = {"transparent":"ProductFeature_transparent__19wqF","section":"ProductFeature_section__i109R","title":"ProductFeature_title__i9i6p"};